<template>
  <DrawablePhotoV1OrV2
    v-if="hasPhoto"
    :image="item.params"
    :drawing="drawing"
    :title="$t('Annotate image')"
    :remove-button-title="$t('Remove annotation')"
    :can-be-deleted="false"
    @change="valueChanged"
  />
</template>

<script>
  import { DrawablePhotoV1OrV2 } from '@/_legacy/components/DrawablePhoto/DrawablePhotoV1OrV2';
  import { isEmpty } from 'lodash/fp';

  // seems like used only on preview?
  // means uploaded photo not saved, no need to upload it to assets
  export default {
    name: 'ConductInspectionItemQuestionAnnotation',
    components: { DrawablePhotoV1OrV2 },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      drawing() {
        return this.item.response && this.item.response.drawing
          ? this.item.response.drawing
          : null;
      },
      hasPhoto() {
        return !isEmpty(this.item.params);
      }
    },
    methods: {
      valueChanged(drawing) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response: { drawing },
          responded: !!drawing,
        });
      },
    },
  };
</script>
